import script from "./agentRowHeightButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./agentRowHeightButton.vue?vue&type=script&setup=true&lang=ts"

import "./agentRowHeightButton.vue?vue&type=style&index=0&id=79528272&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79528272"]])

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
